export default {"src":"/_next/static/media/Gallstones.9afaf431.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};